




























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SvgResultsEmpty from "@/assets/img/ResultsEmpty.vue";

@Component({
  components: {
    SvgResultsEmpty
  }
})
export default class EmptyStateSimple extends Vue {
  @Prop({}) icon!: string;
  @Prop({}) captions!: any;
  $refs!: {};
}
